import { render, staticRenderFns } from "./CrearButton.vue?vue&type=template&id=34826e6b&scoped=true&"
import script from "./CrearButton.vue?vue&type=script&lang=ts&"
export * from "./CrearButton.vue?vue&type=script&lang=ts&"
import style0 from "./CrearButton.vue?vue&type=style&index=0&id=34826e6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34826e6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('34826e6b', component.options)
    } else {
      api.reload('34826e6b', component.options)
    }
    module.hot.accept("./CrearButton.vue?vue&type=template&id=34826e6b&scoped=true&", function () {
      api.rerender('34826e6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/CrearButton.vue"
export default component.exports